import { basic, initSidebar, initTopbar } from './modules/layouts';
import { imgLazy, imgPopup, initClipboard } from './modules/plugins';

basic();
initSidebar();
initTopbar();
imgLazy();
imgPopup();
initClipboard();
